import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2c88a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "x" }
const _hoisted_4 = { class: "popup-text" }
const _hoisted_5 = { class: "popup-title" }
const _hoisted_6 = { class: "popup-description" }
const _hoisted_7 = { class: "message-container" }
const _hoisted_8 = { class: "message-label" }
const _hoisted_9 = { class: "input-label-text-color" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-label-symbol-color" }, "*", -1))
const _hoisted_11 = { class: "message-content" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: "/img/close-btn.svg",
          class: "close-popup-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.declinePopup.title" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.declinePopup.description" })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.declinePopup.label.decline" })
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryText) = $event)),
            class: "message-textarea",
            placeholder: _ctx.i18n.t('dashboard.declinePopup.textareaPlaceholder')
          }, null, 8, _hoisted_12), [
            [_vModelText, _ctx.queryText]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button-text cancel-button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.declinePopup.cancelButton" })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button-text decline-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.declinePopup.declineButton" })
          ])
        ])
      ])
    ])
  ]))
}